import { StateCreator } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { StoreName } from '../../constants';
import { MiddlewaresList } from './types';

/*
Example:

export const useBetslipLsStore = createHookStore(
  STORE_NAMES.BETSLIP_LS,
  initialState,
  [[persist, { name: LOCAL_STORAGE_KEYS.BETSLIP_LS_STORE }]]
);

middlewares is: Array<MiddlewareDescriptor>

MiddlewareDescriptor is: [mwFunction, mwArgs]

mwFunction is: (initFn, mwArgs) => {}
where initFn is store initializer, mwArgs - arbitrary args that middleware is expecting

TODO: remove this comment when typescript types are added and docs updated with valid example
*/
// TODO extract middleware types from middlewares (those are for Mis and Mos)
export const withMiddleware = <T>(
  stateCreator: StateCreator<T>,
  storeName: StoreName,
  middlewares?: MiddlewaresList<T>
) => {
  let appliedMiddleware = subscribeWithSelector(stateCreator);

  if (middlewares) {
    for (const [mwFn, mwArgs] of middlewares) {
      appliedMiddleware = mwFn(appliedMiddleware, mwArgs);
    }
  }

  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_ENV !== 'node'
  ) {
    // eslint-disable-next-line global-require, @typescript-eslint/no-require-imports
    const { devtools } = require('zustand/middleware');

    appliedMiddleware = devtools(appliedMiddleware, { name: storeName });
  }

  return appliedMiddleware;
};
